import FAIcon from "@/components/FAIcon";
import {
  Badge,
  Box,
  Flex,
  HStack,
  IconButton,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";

const GameIframe = ({ 
  game, 
  gameUrl, 
  onClose, 
  height = "400px",
  showHeader = true 
}) => {
  if (!game || !gameUrl) {
    return (
      <Box
        bg="black"
        borderRadius="lg"
        height={height}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <VStack spacing={4}>
          <Spinner size="xl" color="white" />
          <Text color="white">Loading game...</Text>
        </VStack>
      </Box>
    );
  }

  return (
    <Box
      bg="black"
      borderRadius="lg"
      overflow="hidden"
      height={height}
      position="relative"
    >
      {/* Header */}
      {showHeader && (
        <Flex
          bg="gray.800"
          color="white"
          py={2}
          px={4}
          align="center"
          justify="space-between"
          borderBottom="1px solid"
          borderColor="gray.600"
        >
          <HStack spacing={3}>
            <Text fontSize="md" fontWeight="bold">
              {game.name_zh || game.name}
            </Text>
            {game.type && (
              <Badge
                colorScheme={
                  game.type === 'origin' ? 'blue' :
                  game.type === 'scratch' ? 'green' : 'purple'
                }
                textTransform="capitalize"
                fontSize="xs"
              >
                {game.type}
              </Badge>
            )}
          </HStack>
          
          <IconButton
            aria-label="Close game"
            icon={<FAIcon type="xmark" />}
            onClick={onClose}
            variant="ghost"
            color="white"
            size="sm"
            _hover={{ bg: "gray.700" }}
          />
        </Flex>
      )}

      {/* Game Iframe */}
      <Box 
        w="100%" 
        h={showHeader ? "calc(100% - 50px)" : "100%"}
        position="relative"
      >
        <iframe
          src={gameUrl}
          width="100%"
          height="100%"
          style={{
            border: "none",
            backgroundColor: "black",
          }}
          allow="fullscreen; gamepad; microphone; camera"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
          title={`JFF Game - ${game.name}`}
        />
      </Box>
    </Box>
  );
};

export default GameIframe;
